import { createAction, props } from '@ngrx/store';
import { ImagesContainer } from 'ZalamoLibrary/src/lib/upload/graphql';
import { ImagesSelectedInContext } from '@ui/image-management/images-in-context-drawer/types';
import { PhotoStatusOnTheList } from '@ui/image-management/image-viewer/types';

export const PickFilesFromContext = createAction(
  '[Photographer] FilePicker',
  props<{
    limit: number;
    context: ImagesContainer;
    contextId: string;
    taskId: string;
    skip?: string[];
    statusList?: Record<string, PhotoStatusOnTheList>;
  }>()
);
export const PickFilesFromContextResult = createAction(
  '[Photographer] FilePickerResult',
  props<{ taskId: string; results: ImagesSelectedInContext }>()
);
